import { useEffect } from 'react';
import { getIsOnProductionEnvironment, UserData, Event } from '@bizzabo/entities';
import { initGainsightPx, identifyUserToGainsight } from './gainsightPxEmbed';

const useGainsightPx = (user: UserData, event: Event) => {
    const { id, primaryEmail, firstName, lastName } = user ?? {};

    useEffect(() => {
        const isValidUser = id && primaryEmail;
        const isOnProd = getIsOnProductionEnvironment();

        if (isValidUser && isOnProd) {
            // TODO: move the Gainsight Key into a config file
            initGainsightPx('AP-AWDDKDRMISDJ-2') &&
                identifyUserToGainsight({
                    userId: id,
                    primaryEmail,
                    firstName,
                    lastName,
                    accountId: event.accountId,
                    eventName: event.name,
                });
        }
    }, [id, primaryEmail, firstName, lastName]);
};

export default useGainsightPx;
